import React from 'react';
import Loader from "react-js-loader";

const DataLoader = () => {
  return (
    <Loader type="spinner-circle" bgColor={"black"} title={"Loading Data..."} color={'black'} size={100} />
  );
};

export default DataLoader;